import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import { Stack, Box } from '@mui/material';
import Toolbar from '@mui/material/Toolbar';
import logos from '../assets/lemlogos.png';
import FileViewer from '../FileViewer';
import { styled } from '@mui/material/styles';

const Logo = styled('img')({
  maxWidth: '100%',
  maxHeight: '48px',
  objectFit: 'contain',
});

export default function Footer() {
  const [open, setOpen] = React.useState(false);
  const [selectedFile, setSelectedFile] = React.useState(null);

  const handleSelectFile = () => {
    setSelectedFile({
      label: "Aviso de Privacidad",
      src: "https://s3.amazonaws.com/lideresenmovimiento.s3/Aviso+de+Privacidad.pdf",
      type: 'PDF',
    },);
    setOpen(true);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" sx={{ backgroundColor:'#268c83' }}>
        <Toolbar
          variant="dense"
          sx={{ justifyContent: 'space-between', fontSize:'14px', zIndex: 1100, flexDirection: { xs: 'column', md: 'row' } }}
        >
          <Logo src={logos} alt="Líderes en Movimiento Logo" />
          <Stack direction="row" spacing={1} p={2}>
            <span>@ Líderes en Movimiento</span>
            <span>|</span>
            <span>Todos Los Derechos Reservados</span>
            <span>|</span>
            <Box sx={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={handleSelectFile}>Aviso de Privacidad</Box>
            {open && (
              <FileViewer
                open={open}
                setOpen={setOpen}
                src={selectedFile.src}
                label={selectedFile.label}
                type={selectedFile.type}
              />
            )}
          </Stack>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
